import { gql } from '@apollo/client';

export const APPROVE_PROFILE_CHANGE = gql`
    mutation ProfileChangeApprove($id: ID!, $comment: String) {
        profileChangeApprove(id: $id, comment: $comment) {
            changeRequest {
                id
                status
                reviewedAt
                reviewedBy {
                    firstName
                    lastName
                }
            }
        }
    }
`;

export const REJECT_PROFILE_CHANGE = gql`
    mutation ProfileChangeReject($id: ID!, $comment: String!) {
        profileChangeReject(id: $id, comment: $comment) {
            changeRequest {
                id
                status
                reviewedAt
                reviewedBy {
                    firstName
                    lastName
                }
            }
        }
    }
`;
